export type PlanLimitFeature = 'packaged_services' | 'faqs';

const NOUNS: Record<PlanLimitFeature, { one: string; many: string; heading: string }> = {
    packaged_services: { one: 'packaged service', many: 'packaged services', heading: 'Packaged services' },
    faqs: { one: 'FAQ', many: 'FAQs', heading: 'FAQs' },
};

export function isPlanLimitFeature(value: unknown): value is PlanLimitFeature {
    return value === 'packaged_services' || value === 'faqs';
}

export function overPlanLimitGuidance(feature: PlanLimitFeature, limit: number, excess: number): string {
    const nouns = NOUNS[feature];
    if (limit === 0) {
        return `${nouns.heading} aren't available on the free plan. Remove them to save changes here, or upgrade to Pro.`;
    }
    return `Free plans show up to ${limit} ${limit === 1 ? nouns.one : nouns.many} on your profile. Remove ${excess} to save changes here, or upgrade to Pro.`;
}

export function atPlanLimitGuidance(feature: PlanLimitFeature, limit: number): string {
    const nouns = NOUNS[feature];
    if (limit === 0) {
        return `${nouns.heading} aren't available on the free plan. Upgrade to Pro to add them.`;
    }
    return `Free plans can have up to ${limit} ${limit === 1 ? nouns.one : nouns.many}. Upgrade to Pro to add more.`;
}
